import { lazy } from 'react';

import { NavigateWithParams } from '@/utils/NavigateWithParams';

const SurveyRoutes = lazy(() =>
	import('@/features/survey').then(({ SurveyRoutes }) => ({ default: SurveyRoutes }))
);

// these routes are separate as they need to be accessible for logged-in AND logged-out users

export const patientFacingRoutes = [
	{
		path: '/survey/*',
		element: <SurveyRoutes />,
		doNotLoadAnalytics: true, // Do not load analytics from the app route on this page. Analytics are loaded from SurveyContainer instead to ensure user's language is set.
	},
	{
		path: '/e/:id',
		element: (
			<NavigateWithParams
				to={{
					// Note 1
					pathname: '/survey/:id',
					search: 'm=email',
				}}
				replace
			/>
		),
	},
	{
		path: '/s/:id',
		element: (
			<NavigateWithParams
				to={{
					// Note 1
					pathname: '/survey/:id',
					search: 'm=sms',
				}}
				replace
			/>
		),
	},
	{
		path: '/ui/survey/:id/contact-request',
		element: (
			<NavigateWithParams
				to={{
					// Note 1
					pathname: '/survey/:id/contact-request',
				}}
				replace
			/>
		),
	},
	{
		path: '/r/*',
		element: <SurveyRoutes />,
		doNotLoadAnalytics: true, // Do not load analytics from the app route on this page.
	},
];
